<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_puzzle') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_size') }}
            span(slot="value") {{ puzzleGame.difficult.name }}
        game-preview-setting(v-if="parameters.negativeAnswers")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') }}
            span(slot="value") {{ gameName }}
        game-preview-setting
            span.game-preview__image-label(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_image') }}
            .image-preview-container(
                slot="image",
                v-if="puzzleGame.image",
            )
                .image-preview(
                    :style='`background: url("${puzzleGame.image}") no-repeat center; background-size: contain`',
                )
        game-preview-setting(:in-puzzle="true")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_gameParams') }}
            div(slot="value") &nbsp;
        games-list(
            :games="puzzleGame.games",
            :in-browse-game="true",
        )
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamesList from '../../games/GamesList.vue';
    import getBase64FromUrl from '../../../utils/getBase64FromUrl';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        data () {
            return {
                gameNames: {
                    "AdditionAndSubtraction": this.$i18n.t('common.common_gameName_additionAndSubtraction'),
                    "AdditionAndSubtractionWithTime": this.$i18n.t('common.common_gameName_additionAndSubtractionWithTime'),
                    "InteractiveFlashCards": this.$i18n.t('common.common_gameName_interactiveFlashCards'),
                    "MultiplicationAndDivision": this.$i18n.t('common.common_gameName_multiplicationAndDivision'),
                    "Equation": this.$i18n.t('common.common_gameName_equation'),
                    "Anzan": this.$i18n.t('common.common_gameName_anzan'),
                }
            }
        },
        created () {
            if (this.isBrowseForBattle) {
                this.assignImage();
            }
        },
        computed: {
            puzzleGame() {
                return this.$store.state.games.puzzle || this.parameters;
            },
            gameName () {
                if (this.puzzleGame.games[0].slug === 'Anzan' && this.puzzleGame.games[0].parameters.default.withTime) {
                    return this.$i18n.t('common.common_gameName_anzanWithTime');
                }
                return this.gameNames[this.puzzleGame.games[0].slug];
            },
            isBrowseForBattle() {
                return !this.$store.state.games.puzzle;
            }
        },
        methods: {
            async assignImage() {
                this.parameters.image = await this.getBase64ImageFromUrl(
                    this.$options.filters.apiFile(this.parameters.imageSrc)
                );
            },
        },
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
            GamesList
        },
    }
</script>

<style scoped lang="scss">
    .image-preview-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 70px 0 20px 0;
        @media screen and (max-width: 575px) {
            margin: 30px 0 0 0;
        }
    }
    .image-preview {
        width: 200px;
        height: 200px;
        border-radius: 10px;
        background: $x-color-white;
    }
    .game-preview__image-label {
        width: 100%;
    }
</style>
